import {
  IconCircleCheck,
  IconExclamationCircle,
  IconX,
  IconAlertSquareRounded,
} from "@tabler/icons-react";
import { motion, AnimatePresence } from "framer-motion";

import useNotification from "./use_notification";

function Notification() {
  const notify = useNotification();

  return (
    <>
      {/* Global notification live region, render this permanently at the end of the document */}
      <div
        aria-live="assertive"
        className="z-50 pointer-events-none fixed inset-x-0 top-0 flex items-end px-4 py-6 sm:items-start sm:p-6"
      >
        <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
          {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
          <AnimatePresence>
            {notify.state.show && (
              <motion.div>
                <div className="w-96 shadow-lg rounded-lg bg-slate-50">
                  <div className="p-4">
                    <div className="flex items-start">
                      <div className="flex-shrink-0">
                        {notify.state.type === "success" && (
                          <IconCircleCheck
                            aria-hidden="true"
                            className="h-6 w-6 text-green-400"
                          />
                        )}
                        {notify.state.type === "error" && (
                          <IconExclamationCircle
                            aria-hidden="true"
                            className="h-6 w-6 text-red-400"
                          />
                        )}
                        {notify.state.type === "warn" && (
                          <IconAlertSquareRounded
                            aria-hidden="true"
                            className="h-6 w-6 text-orange-400"
                          />
                        )}
                      </div>
                      <div className="ml-3 w-0 flex-1 pt-0.5">
                        <p className="text-lg font-medium text-gray-900">
                          {notify.state.title}
                        </p>
                        <p className="mt-1 text-md text-gray-500">
                          {notify.state.message}
                        </p>
                      </div>
                      <div className="ml-4 flex flex-shrink-0">
                        <button
                          type="button"
                          onClick={() => {
                            notify.close();
                          }}
                          className="inline-flex rounded-md bg-inherit text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                        >
                          <span className="sr-only">Close</span>
                          <IconX aria-hidden="true" className="h-5 w-5" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </>
  );
}

export default Notification;
